import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { ScenarioService } from '../services/scenario.service';
import { ActivatedRoute } from '@angular/router';
import { PlayerSessionService } from '../services/player-session.service';
import { HelperService } from '../services/helper.service';
import { PlayerService } from '../services/player.service';

@Component({
  selector: 'app-results-detailed',
  templateUrl: './results-detailed.component.html',
  styleUrls: ['./results-detailed.component.scss'],
})
export class ResultsDetailedComponent implements OnInit, OnDestroy {
  scenario: any;
  isLoading = false;
  scenarioId: any;
  sessionId: any;
  session: any;
  stats: any;
  log: any;
  scenarios: any;

  bsModalRef?: BsModalRef;

  scenarioSubscription: any;
  scenarioDataSubscription: any;
  userSubscription: any;
  environment = environment;
  comments: any = [];
  taskResponses: any = [];

  viewMode = 'tabbed';

  eventTypes = [
    { id: 'makeChoice', label: 'Make Choice' },
    { id: 'goToStep', label: 'Go to Step' },
    { id: 'componentPressed', label: 'Component Pressed' },
    { id: 'componentHovered', label: 'Component Hovered' },
    { id: 'componentHoverOut', label: 'Component  Hovered Out' },
    { id: 'componentDropped', label: 'Component Dropped' },
    { id: 'hotspotPressed', label: 'Hotspot Pressed' },
    { id: 'quizAnswered', label: 'Quiz Question Answered' },
    { id: 'quizCompleted', label: 'Quiz Completed' },
    { id: 'formSubmitted', label: 'Form Submitted' },
    { id: 'chatStem', label: 'Chat Stem' },
    { id: 'videoEnd', label: 'Video Ended' },
    { id: 'activityEnded', label: 'Activity Ended' },
    { id: 'varSet', label: 'Variable Set' },
    { id: 'pickItems', label: 'Inventory task' },
    { id: 'restarted', label: 'Restarted' },
    { id: 'addToInventory', label: 'Add to Inventory' },
    { id: 'removeFromInventory', label: 'Remove from Inventory' },
  ];
  journeyFilter = [
    'makeChoice',
    'goToStep',
    'pickItems',
    'chatStem',
    'componentPressed',
    'hotspotPressed',
    'quizAnswered',
    'quizCompleted',
    'formSubmitted',
    'restarted',
  ];

  constructor(
    private scenarioService: ScenarioService,
    private route: ActivatedRoute,
    private playerSessionService: PlayerSessionService,
    public helperService: HelperService,
    public playerService: PlayerService,
  ) {}

  ngOnInit(): void {
    // get some data
    this.isLoading = true;
    this.route.params.subscribe((params) => {
      this.sessionId = this.route.snapshot.params['sessionId'];
      this.scenarioDataSubscription = this.scenarioService.data.subscribe(
        (responseData) => {
          this.scenario = responseData;
          this.isLoading = false;
          this.isLoading = false;
          // get the session

          this.playerSessionService
            .fetch(this.sessionId)
            .subscribe((sessionResponse) => {
              this.session = sessionResponse;

            // get scenario

            console.log('1/' + this.session.published_hash + '.json');
            
            this.scenarioService
            .loadScenario('1/' + this.session.published_hash + '.json')
            .subscribe((responseData) => {
              this.scenario = responseData;
            });
            console.log(this.scenario);

              this.session.user = JSON.parse(this.session.user);
              this.session.vars = JSON.parse(this.session.vars);
              
              this.session.session_data
                ? (this.session.session_data = JSON.parse(
                    this.session.session_data,
                  ))
                : null;
              this.log = JSON.parse(this.session.log);

              // build the task responses array
              let taskTypes = ['pickItems', 'quizCompleted', 'formSubmitted'];
              let quizAnswers: any = {};
              this.session.route = [];
              this.session.route.push(
                this.scenarioService.getStartStep(this.scenario)?.step_id,
              );
              this.log.forEach((logItem: any) => {
                // if it's a quiz answered then add to an array?
                if (logItem.event == 'quizAnswered') {
                  if (!quizAnswers[logItem.data.id]) {
                    quizAnswers[logItem.data.id] = [];
                  }
                  quizAnswers[logItem.data.id].push(logItem);
                }
                if (
                  logItem.event == 'quizCompleted' &&
                  quizAnswers[logItem.data.id]
                ) {
                  logItem.data.answers = quizAnswers[logItem.data.id];
                }

                if (taskTypes.indexOf(logItem.event) !== -1) {
                  this.taskResponses.push(logItem);
                }

                if (logItem.event == 'goToStep') {
                  this.session.route.push(logItem.data.id);
                }
                if (logItem.event == 'restarted') {
                  this.session.route.push('RESTART');
                }
              });
            });

        },
      );
    });
  }

  getChoice(choiceId: string, scenarioData: any): any {
    let returnChoice;
    scenarioData.choices.forEach((choice: any) => {
      if (choice.choice_id == choiceId) {
        returnChoice = choice;
      }
    });
    return returnChoice;
  }

  getStep(stepId: string, scenarioData: any): any {
    let returnstep;
    scenarioData?.steps.forEach((step: any) => {
      if (step.step_id == stepId) {
        returnstep = step;
      }
    });
    return returnstep;
  }

  ngOnDestroy(): void {
    this.scenarioSubscription?.unsubscribe();
    this.scenarioDataSubscription?.unsubscribe();
    this.userSubscription?.unsubscribe();
  }

  getTypeOf(value: any) {
    return typeof value;
  }

  getFieldValue(any: any) {
    return any;
  }

  hasVars(session: any) {
    let hasVars = false;

    session?.vars?.forEach((_var: any) => {
      if (_var.name != 'score' && _var.name != 'user') {
        hasVars = true;
      }
    });

    return hasVars;
  }

  onToggleFilterEvent(event: any) {
    if (this.journeyFilter.indexOf(event.id) == -1) {
      this.journeyFilter.push(event.id);
    } else {
      this.journeyFilter.splice(this.journeyFilter.indexOf(event.id), 1);
    }
  }
}
